import { render, staticRenderFns } from "./DeveloperLeads.vue?vue&type=template&id=17a3ac16"
import script from "./DeveloperLeads.vue?vue&type=script&lang=js"
export * from "./DeveloperLeads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports